var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Dropdown',{attrs:{"options":_vm.list_countries,"disabled":false,"name":"country","maxItem":10,"placeholder":"Please select a country"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }